import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const DEFAULT_DESCRIPTION =
  "Cyberate Investments Pty Ltd - Investment & Commercial Decision Intelligence. A DDDI Group company applying Data, Development, Design and Insight to property and private commercial decisions.";

const SEO = ({ title, description }) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="robots" content="noindex, follow" />
      <meta name="description" content={description || DEFAULT_DESCRIPTION} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta property="og:title" content={title} />
      <meta
        property="og:description"
        content={description || DEFAULT_DESCRIPTION}
      />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SEO;
